<template>
  <div id="tbView">
    <p class="tbrLcMsg">
      {{ tbtsnr }}
      <!-- <span class='lookPdf' @click='lookJmPdf'>解密操作手册</span> -->
      </p>
    <ul class="tbrSteps" >
      <li v-for="(item, index) in lcSteps" :key="index" :style="{ 'width': 100/lcSteps.length + '%' }">
        <!-- 还没到的节点 -->
        <p
          :class="[
            { over: item.zt == '2' || item.zt == '1' },
            { active: item.id == djlcId },
          ]"
          @click="changeStep(item)"
        >
          {{ item.ycmc }}
        </p>
        <!-- 签到 -->
        <div v-if="item.tbrycdz == '/tbqd'">
          <el-button
            @click="tbrDo('tbqd')"
            :disabled="tbqdzt"
            type="primary"
            v-if="item.qdzt == null"
            >签到</el-button
          >
          <el-button
            @click="tbrDo('tbqd')"
            :disabled="item.qdzt == '0'"
            type="primary"
            v-if="item.qdzt == '0' || item.qdzt == '1'"
            >签到</el-button
          >
          <span class="success" v-if="item.qdzt == '2'">已签到</span>
          <span class="red" v-if="item.qdzt == '3'">未签到</span>
        </div>
        <div v-if="item.tbrycdz == '/tbkbdjs'">

        </div>
        <!-- 有效性审查 -->
        <div v-if="item.tbrycdz == '/tbyxxsc'">
          <span class="success" v-if="item.yxxsczt == '1'">已通过</span>
          <span class="red" v-if="item.yxxsczt == '2'">未通过</span>
        </div>
        <!-- 解密 -->
        <div v-if="item.tbrycdz == '/tbjm'">
          <el-button
            @click="tbrDo('tbjm')"
            :disabled="item.jmzt == '0' || item.jmzt == null"
            type="primary"
            v-if="item.jmzt == '0' || item.jmzt == '1' || item.jmzt == null"
            >解密</el-button
          >
          <span class="success" v-if="item.jmzt == '2'">已解密</span>
          <span class="red" v-if="item.jmzt == '3'">未解密</span>
          <span class="red" v-if="item.jmzt == '4'">解密失败</span>
        </div>
        <!--多次报价 -->
        <div v-if="item.tbrycdz == '/tbbj'">
          <span class="success" v-if="flag ||item.zt=='2'">已确认</span>
          <el-button
            @click="tbrDo('tbbj')"
            :disabled="flag"
            type="primary"
            v-else
            >确认</el-button
          >
        </div>
        <!-- 唱标 -->
        <div v-if="item.tbrycdz == '/tbcb'">
          <span class="success" v-if="item.cbzt == '1'">已唱标</span>
        </div>
        <!-- 确认 -->
        <div v-if="item.tbrycdz == '/tbqr'">
          <span class="success" v-if="item.qrzt == '2'">已确认</span>
          <el-button
            @click="tbrDo('tbqr')"
            :disabled="item.qrzt == '0' || item.qrzt == null"
            type="primary"
            v-else
            >确认</el-button
          >
        </div>
      </li>
    </ul>
    <component
      v-bind:is="currentView"
      ref="view"
      :djlcId="djlcId"
      @send="send"
      @isShow="isShow"
    ></component>
  </div>
</template>
<script>
import tbqd from "../views/tbqd";
import tbyxxsc from "../views/tbyxxsc";
import tbjm from "../views/tbjm";
import tbcb from "../views/tbcb";
import tbqr from "../views/tbqr";
import tbbj from "../views/tbbj";
import tbkbdjs from "../views/tbkbdjs";
export default {
  name: "tbView",
  components: {
    tbqd,
    tbyxxsc,
    tbjm,
    tbcb,
    tbqr,
    tbbj,
    tbkbdjs,
  },
  data() {
    return {
      tbtsnr: "", //投标人页面流程消息提醒
      tbqdzt: true,
      lcSteps: [],
      currentView: "",
      djlcId: "",
      widthVar: "20%",
      flag: "",
    };
  },
  methods: {
    getData() {
      let para = {};
      this.$api
        .getkbxmlcTb(para)
        .then((res) => {
          if (res.data.meta.success) {
            // 注释看效果，要放开
            this.lcSteps = res.data.data.kbxmlcListTb;
            this.lcSteps[this.lcSteps.length - 1].ycmc = "确认";
            this.lcSteps[this.lcSteps.length - 1].tbrycdz = "/tbqr";
            if (this.lcSteps[this.lcSteps.length - 1].zt == "2") {
              this.lcSteps[this.lcSteps.length - 1].zt = "1";
            }
            if (this.lcSteps.length == 6) {
              this.widthVar = "16.6666%";
            }
            this.lcSteps.forEach((obj, index) => {
              if (obj.zt == "1") {
                this.currentView = obj.tbrycdz.split("/")[1];
                this.djlcId = obj.id;
                if (obj.tbrycdz == "/tbqd" && obj.qdzt == null) {
                  if (res.data.data.kbxm.tbqdzt == "0") {
                    this.tbqdzt = true;
                    this.tbtsnr = "请耐心等待主持人开启签到！";
                  } else if (res.data.data.kbxm.tbqdzt == "1") {
                    this.tbqdzt = false;
                    this.tbtsnr = "请投标人及时使用CA完成签到！";
                  }
                } else {
                  this.tbtsnr = obj.tbtsnr;
                }
              } else if (obj.zt == "2" && this.lcSteps[index + 1].zt == "0") {
                this.currentView = obj.tbrycdz.split("/")[1];
                this.djlcId = obj.id;
                this.tbtsnr = obj.tbtsnr;
                this.$set(this.lcSteps[index], "zt", "1");
              }
            });
            localStorage.setItem("lcSteps", JSON.stringify(this.lcSteps));
            this.$refs.view.getData();
          }
        })
        .catch(() => {});
    },
    changeStep(obj) {
      if (obj.zt == "2" || obj.zt == "1") {
        this.currentView = obj.tbrycdz.split("/")[1];
        this.djlcId = obj.id;
      } else {
        return;
      }
    },
    //投标人签到解密确认操作
    tbrDo(lx) {
      this.$refs.view.tbrDo(lx);
    },
    isShow(e) {
      this.flag = Boolean(e);
    },
    send(e) {
      var obj = JSON.parse(e);
      let lx = obj.lx;
      if (lx == "tb") {
        if (obj.data.index == 4) {
          this.getData();
        } else {
          let zt = "";
          switch (obj.data.index) {
            case 0:
              zt = "qdzt";
              this.tbqdzt = true;
              break;
            case 1:
              zt = "yxxsczt";
              break;
            case 2:
              zt = "jmzt";
              break;
            case 3:
              zt = "cbzt";
              break;
          }
          this.$set(this.lcSteps[obj.data.index], zt, obj.data.msg);
        }
        if (obj.data.all) {
          this.$emit("send", JSON.stringify(obj));
        }
      } else if (lx == "sqbj") {
        let obj = {
          lx: "sqbj",
        };
        this.$emit("send", JSON.stringify(obj));
      }
    },
    lookJmPdf(){
      window.open('https://jypt.zhaotx.cn/static/tools/临海小额系统开标解密帮助手册.pdf','_blank')
    }
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less">
#tbView {
  height: 100%;
  .tbrLcMsg {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #fffbe9 url("../assets/images/lbRed.png") no-repeat 20px center;
    border: 1px solid #f5dcb3;
    padding: 0 20px 0 50px;
    font-weight: bold;
    color: @base-color;
    font-size: 16px;
    margin-bottom: 10px;
    span.lookPdf{
      color:#0060b2;
      cursor: pointer;
      float:right;
      text-decoration: underline;
    }
  }
  .tbrSteps {
    margin-bottom: 10px;
    height: 100px;
    width: 100%;
    li {
      display: block;
      float: left;
      border: 1px solid #ddd;
      text-align: center;
      p {
        background: @base-Bg;
        border-bottom: 1px solid #ddd;
        height: 50px;
        line-height: 50px;
        color: #999;
        cursor: not-allowed;
      }
      p.over {
        color: #333;
        cursor: pointer;
      }
      p.active {
        background: @base-color;
        color: #fff;
        font-weight: bold;
      }
      div {
        height: 50px;
        line-height: 50px;
      }
    }
    li + li {
      border-left: none;
    }
  }
  > div {
    height: calc(~"100% - 160px");
    background: #fff;
  }
  > div.twoBox {
    .redBox {
      height: 150px;
      line-height: 150px;
      background: #fdf0f3;
      border: 1px solid @border-color;
      border-top: 2px solid @base-color;
      margin-bottom: 10px;
      text-align: center;
      p.red {
        font-size: 36px;
        font-weight: bold;
      }
      > div {
        width: 650px;
        margin: 0 auto;
        height: 148px;
        p {
          float: left;
          font-size: 20px;
          color: #333;
        }
        > div {
          width: 530px;
          margin: 0 auto;
          height: 148px;
          padding-top: 35px;
        }
      }
    }
    .box {
      height: calc(~"100% - 160px");
      border: 1px solid #ddd;
      background: #fff;
    }
  }
  table.list {
    width: 80%;
    min-width: 800px;
    margin: 80px auto 80px auto;
    border-collapse: collapse;
    td {
      height: 40px;
      border: 1px solid #ddd;
      text-align: center;
    }
    thead {
      td {
        font-weight: bold;
        color: #333;
      }
    }
  }
  .ca {
    width: 600px;
  }
  .ewm {
    width: 400px;
  }
}
</style>
